/** Incoming transitions arrive at the key's time. Legacy tracks use outgoing easing. */
export interface IncomingTransition {
  transition?: 'cut' | 'transition' | undefined;
  durationSeconds?: number | 'interval' | undefined;
  easing: 'linear' | 'smooth';
}
export function transitionWindow(key: IncomingTransition & { seconds: number }, previousSeconds = 0) {
  const gap = Math.max(0, key.seconds - previousSeconds);
  const requested = key.durationSeconds ?? 2;
  const duration = key.transition === 'cut' ? 0 : requested === 'interval' ? gap : Math.min(requested, gap);
  return { start: key.seconds - duration, end: key.seconds, duration, requested };
}
export function transitionEase(amount: number, easing: 'linear' | 'smooth') {
  const t = Math.max(0, Math.min(1, amount));
  return easing === 'linear' ? t : t * t * t * (t * (t * 6 - 15) + 10);
}
export function interpolateCameraValue(from: number, to: number, amount: number, rotation = false) {
  let delta = to - from;
  if (rotation && Math.abs(delta) < 360) delta = ((delta + 540) % 360) - 180;
  const value = from + delta * amount;
  return rotation && (value < 0 || value > 360) ? ((value % 360) + 360) % 360 : value;
}
